module.exports = __webpack_public_path__ + "autopilot-1-ed3334ba5c9e26f9a19a15132cf59e5f.webp";